import React, { useContext, useEffect, useRef, useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Button from '@mui/material/Button';
import { AuthContext } from '../../context/auth-context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
// import { MdPostAdd } from "react-icons/md";
// import { FiEdit } from "react-icons/fi";
// import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons';

import './navLinks.css';



const NavLinks = () => {
  const auth = useContext(AuthContext);
  const history = useHistory();
  const dropRef = useRef(null)
  const { user } = useContext(AuthContext);
 
  const [drop, setDrop] = useState(null);

  const handleDrop = (menu) => {
    setDrop( drop === menu ? null : menu); 
  }
 
 
  const handleLogout = () => {
    const confirmLogout = window.confirm("Are you sure you want to log out?");
    if(confirmLogout){
      auth.logout();
     
      alert("You have been logged out.");  
      history.push('/');
    } else {
      alert("Logout cancelled.")
    }
  };

  //Close the dropdown when clicking outside
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropRef.current && !dropRef.current.contains(event.target)){
          setDrop(null); // close the dropdown
        }
      };
      
      // Add event listener to the document
      document.addEventListener('mousedown', handleClickOutside);
  
      // Cleanup the event listener when component unmounts;
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      };
    }, []) // Empty dependency array to run only once when components mounts

  return (
    <main ref={dropRef}>
      <div onClick={() => handleDrop('menu')}className='nav-control'>
          
        <div className=''>
          {/* User */}
          {auth.isLoggedIn && auth.user && auth.user.role === 'user' && (
            <img src={`${process.env.REACT_APP_ASSET_URL}/${user.image}`} alt={user.name} title={user.name} className='images_user_admin'/>  
          )} 

          {/* Admin */}
          {auth.isLoggedIn && auth.user && auth.user.role === 'admin' && ( 
            <div className='home-container'>
              <img src={`${process.env.REACT_APP_ASSET_URL}/${user.image}`} alt={user.name} title={user.name} className='images_user_admin'/>
              <p>Admin <br/> {user.name}</p>
            </div>     
          )} 
        </div>

        {/* Drop Menu */}
        <div className={`NavDropMenu ${drop === 'menu' ? 'show' : 'hide'}`}>

          {/* To user posts */}
          {auth.isLoggedIn && auth.user && auth.user.role === 'user' && (
            <><NavLink to='/user' style={{ textDecoration: 'none' }}>
              {/* <img src={`${process.env.REACT_APP_ASSET_URL}/${user.image}`} alt={user.name} title={user.name} style={{width: '50px', height:'50px', borderRadius: '50px'}}/>   */}
              <div className='user_profile'>
                <h3>{user.name}'s Profile</h3>
              </div>
            </NavLink>
            <NavLink to='/posts'>
                <div className='user_profile'>
                  <h3>Posts</h3>
                </div>
              </NavLink>
            </>
          )}

          {/* To admin dashboard */}
          {auth.isLoggedIn && auth.user && auth.user.role === 'admin' && (
            <NavLink to='/admin/dashboard' style={{textDecoration: 'none'}}>
              <div className='user_profile'>
                <h3>Admin Dashboard </h3>
              </div>
           </NavLink>
          )}
          {/* Logout */}
          {auth.isLoggedIn && 
          <div className='user_profile_button'>
            <button onClick={handleLogout} >Logout</button>
          </div>
            
          }     
        </div>

        {/* Login */}
        <div>
          <NavLink to='/auth'>
            {!auth.isLoggedIn && <Button id='login-button-cont' variant='contained'>Login</Button>}
            {!auth.isLoggedIn && <FontAwesomeIcon icon={faUser} className='font-controller'/>}
          </NavLink>
        </div>    
      </div> 
    </main>      
  )
}

export default NavLinks; 